export const AQUA_DRAFTS_BASE_URL = 'https://aqua-drafts.web.app'
export const API_BASE_URL_PRODUCTION =
  'https://kinoneconnect-okdftkfcxq-an.a.run.app/api'
export const API_BASE_URL_TEST =
  'https://test-main-backend-366805150657.asia-northeast1.run.app/api'
export const API_BASE_URL_FOR_OUTSOURCING =
  'https://production-outsourcing-delivery-note-366805150657.asia-northeast1.run.app/api'

export const LOCAL_STORAGE_KEY = 'DefaultUserOnSiteDIARY'
export const APPLICATION_VERSION = '1.6.0'

export const REDIRECT_URI_PRODUCTION = 'https://site-diary-morimatsu.web.app'
export const REDIRECT_URI_TEST = 'https://test-site-diary-morimatsu.web.app'
